export default {"src":"/_next/static/media/new-trees-and-or-shrubs.5441bae1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};